import { render, staticRenderFns } from "./SignUpPromos.vue?vue&type=template&id=3dd916fa&scoped=true&"
import script from "./SignUpPromos.vue?vue&type=script&lang=js&"
export * from "./SignUpPromos.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPromos.vue?vue&type=style&index=0&id=3dd916fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd916fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCheckbox,VCol,VForm,VRow,VTextField})
